import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardBody, Table, Button, Spinner } from 'reactstrap';
import { useNotifications, NotificationItem } from '../context/NotificationsContext';
import BreadCrumb from '../components/Common/BreadCrumb';
import { getDashboardNotificationPath } from '../utils/notificationUtils';
import { formatUkDateTime } from '../utils/dateFormat';

const NotificationsPage: React.FC = () => {
  const navigate = useNavigate();
  const { notifications, loading, unreadCount, refreshNotifications, markAsRead, markAllAsRead } = useNotifications();

  useEffect(() => {
    refreshNotifications();
  }, [refreshNotifications]);

  return (
    <>
      <BreadCrumb title="Notifications" pageTitle="Notifications" />
      <Card>
        <CardBody>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <span className="text-muted">
              {unreadCount > 0 ? `${unreadCount} unread` : 'All read'}
            </span>
            <div>
              <Button color="light" size="sm" className="me-2" onClick={() => refreshNotifications()} disabled={loading}>
                {loading ? <Spinner size="sm" /> : <i className="ri-refresh-line" />}
              </Button>
              {unreadCount > 0 && (
                <Button color="primary" size="sm" onClick={markAllAsRead}>
                  Mark all as read
                </Button>
              )}
            </div>
          </div>
          {loading && notifications.length === 0 ? (
            <div className="text-center py-5">
              <Spinner color="primary" />
            </div>
          ) : notifications.length === 0 ? (
            <p className="text-muted text-center py-5 mb-0">No notifications yet.</p>
          ) : (
            <Table responsive hover>
              <thead>
                <tr>
                  <th>Title</th>
                  <th>Message</th>
                  <th>Type</th>
                  <th>Date</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {notifications.map((n: NotificationItem) => {
                  const path = getDashboardNotificationPath(
                    n.actionUrl,
                    n.data as { contentId?: string; orderId?: string; userId?: string },
                    n.type,
                  );
                  return (
                    <tr
                      key={n._id}
                      className={`${!n.read ? 'table-active' : ''} ${path ? 'cursor-pointer' : ''}`}
                      onClick={() => {
                        if (!n.read) markAsRead(n._id);
                        if (path) navigate(path);
                      }}
                      style={path ? { cursor: 'pointer' } : undefined}
                    >
                      <td>{n.title}</td>
                      <td style={{ maxWidth: 280 }} className="text-muted small">
                        {n.message}
                      </td>
                      <td>
                        <span className="badge bg-secondary">{n.type}</span>
                      </td>
                      <td className="text-nowrap">{formatUkDateTime(n.createdAt)}</td>
                      <td onClick={(e) => e.stopPropagation()}>
                        {!n.read && (
                          <Button color="link" size="sm" className="p-0" onClick={() => markAsRead(n._id)}>
                            Mark read
                          </Button>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          )}
        </CardBody>
      </Card>
    </>
  );
};

export default NotificationsPage;
